import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledTriggerItemCard = styled.div`
	display: grid;
	gap: 16px;
	${breakPoints({
		'768': `grid-template-columns: auto 1fr`,
	})};
`;

export const StyledConflictItem = styled.div`
	display: grid;
	width: 100%;
	gap: 16px;
	${breakPoints({
		'768': `grid-template-columns: auto 1fr auto`,
	})};
`;

export const StyledImageOrButton = styled.div<{ autoHeight: boolean }>`
	position: relative;
	aspect-ratio: 16 / 9;
	height: 128px;
	width: 100%;
	flex-shrink: ${breakPoints({
		'768': `
			height: ${({ autoHeight }: { autoHeight?: boolean }) => (autoHeight ? 'auto' : 'full')};
			width: 208px;
		`,
	})};

	> img {
		width: full;
		height: full;
		object-fit: contain;
	}
`;

export const ItemInfoStyle = styled.div`
	display: flex;
	gap: 16px;

	button {
		align-self: flex-start;
	}
`;
